import { Component } from '@angular/core';

@Component({
  selector: "app-main-footer",
  templateUrl: "./main-layout-footer.template.html"
})
export class MainLayoutFooterComponent {
  public footerItems: Object[] = [
    {
      value: "Privacy Policy",
      className: "text-left",
      link: "http://www.my-insurer.net/privacy-policy.html"
    },
    {
      value: "Copyright @ My-Insurer Pte Ltd - Singapore",
      className: "text-center"
    },
    {
      value: "Terms & Conditions",
      className: "text-right",
      link: "http://www.my-insurer.net/term--conditions-users.html"
    }
  ];
}



// WEBPACK FOOTER //
// ./src/app/shared/common/layout/main-layout-footer/main-layout-footer.component.ts